export default "* Område med mange træer samt træstammer eller lign. til at balancere på.\n* Stopur\n* Evt. hulahopring\n* Evt. reb";